import { __decorate } from "tslib";
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ImageUploadMixin from '@/helpers/vue_mixins/v2/ImageUploadMixin';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
import Uploader from '@/components/v2/Uploader';
import BaseImagePlaceholder from '@/components/v2/BaseImagePlacelholder';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import BaseTextArea from '@/components/v2/BaseTextArea';
import ActionButton from '@/components/action_button/Index.vue';
import { requiredProperty, successfulCreate, } from '@/helpers/mixins/LocalizationHelper';
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators';
import { NotificationDeliverySchedule, } from '@/helpers/entities/interfaces/v2/forms/AddNotificationForm';
import moment from 'moment';
import { isNotEmpty } from '@/helpers';
import VEditorField from '@/components/v2/VEditorField.vue';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import { Getter, Mutation } from 'vuex-class';
import CreateSubscriptionNotification from '@/plugins/graphql/mutations/copilot_inbox_manager/create-subscription-notification.gql';
import EditSubscriptionNotification from '@/plugins/graphql/mutations/copilot_inbox_manager/edit-subscription-notification.gql';
import NotificationUploadImage from '@/plugins/graphql/mutations/copilot_inbox_manager/upload-notification-image.gql';
import NotificationRemoveImage from '@/plugins/graphql/mutations/copilot_inbox_manager/remove-notification-image.gql';
import DateTimeField from '@/components/datetime_field/Index.vue';
import FetchProducts from '@/plugins/graphql/queries/v2/copilot_inbox_manager/products.gql';
import AppSegmentations from '@/plugins/graphql/queries/v2/app-segmentations-basic.gql';
import { AppSegmentationBasicModel } from '@/helpers/entities/models/AppSegmentationBasicModel';
import FetchSubscriberCount from '@/plugins/graphql/queries/v2/copilot_inbox_manager/active-subscribers-count.gql';
import FetchDefaultProduct from '@/plugins/graphql/queries/v2/copilot_inbox_manager/notification-default-product.gql';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
import { ECOMMERCE_B2C, SHOPIFY } from '@/helpers/constants/Bundles';
let ComponentName = class ComponentName extends Mixins(FormMixin, ViewportSizeMixin, RouterParamsAppMixin, FormValidationsMixin, Mixins(ImageUploadMixin, WindowSizeListener)) {
    constructor() {
        super(...arguments);
        this.searchInputProduct = '';
        this.searchInputSegment = '';
        this.fileExceeded = false;
        this.hasRejectedFiles = false;
        this.sending = false;
        this.appProducts = [];
        this.appSegments = [];
        this.activeSubscribersCount = '';
        this.form = {
            image: [],
            name: 'Updates and promotions',
            customerSegments: null,
            allActiveDailySubscribers: true,
            typeOfNotification: '',
            productUuid: null,
            // title: '',
            messageBody: '',
            actionButtonLabel: 'View Product',
            scheduleDate: null,
            sendNow: true,
            isTargetRecipients: false,
        };
        this.isActiveDailySubscribers = false;
        this.hasSubmitted = false;
        this.mutationRequestOnFlight = false;
        this.customerSegments = [
            {
                label: 'All Active Daily Subscribers (10)',
                value: 'allActiveDailySubscribers',
            },
            {
                label: 'All Active Subscribers',
                value: 'allActiveSubscribers',
            },
            {
                label: 'All Subscribers',
                value: 'allSubscribers',
            },
            {
                label: 'All Unsubscribers',
                value: 'allUnsubscribers',
            },
        ];
        this.typeOfNotifications = [
            {
                text: 'New Product Announcement',
                value: 'new_product_announcement',
            },
            {
                text: 'Product Discount Promotion',
                value: 'product_discount_promotion',
            },
            {
                text: 'Product Promotion',
                value: 'product_promotion',
            },
        ];
        this.productType = [
            'new_product_announcement',
            'product_discount_promotion',
            'product_promotion',
        ];
        this.products = [
            {
                text: 'Product 1',
                value: 'product-1',
            },
            {
                text: 'Product 2',
                value: 'product-2',
            },
            {
                text: 'Product 3',
                value: 'product-3',
            },
        ];
    }
    get checkImageUnshow() {
        if (this.form.image?.length) {
            const imageStates = this.form.image.map((image) => image.state);
            if (imageStates.every((state) => state === 'deleted')) {
                return false;
            }
            return true;
        }
        return false;
    }
    get productSelection() {
        return this.appProducts.map((product) => {
            return { text: product.name, value: product.uuid };
        });
    }
    get segmentSelection() {
        return this.appSegments
            .filter((segment) => segment.recipientCount > 0) // Filter segments with recipientCount > 0
            .map((segment) => {
            return { text: `${segment.name} (${segment.recipientCount})`, value: segment.uuid };
        });
    }
    onNameChange() {
        this.assignChangedFormData();
    }
    onMessageBodyChange() {
        this.assignChangedFormData();
    }
    onActionButtonLabelChange() {
        this.assignChangedFormData();
    }
    onImageChange() {
        this.assignChangedFormData();
    }
    onDateTimeChange() {
        this.toggleInitialDate();
    }
    // @Watch('notifUuid')
    // private onUuidChange() {
    //   this.form = this.formData;
    // }
    // @Watch('notificationFormData')
    // private onFormDataChange() {
    //   this.form = this.formData;
    // }
    toggleInitialDate() {
        if (this.form.sendNow) {
            this.form.scheduleDate = null;
        }
        else {
            this.form.scheduleDate = new Date().toISOString();
        }
    }
    assignChangedFormData() {
        this.setNotificationFormData({
            image: this.form.image,
            name: this.form.name,
            customerSegments: this.form.customerSegments,
            allActiveDailySubscribers: this.form.allActiveDailySubscribers,
            typeOfNotification: this.form.typeOfNotification,
            productUuid: this.form.productUuid,
            messageBody: this.form.messageBody,
            actionButtonLabel: this.form.actionButtonLabel,
            scheduleDate: this.form.scheduleDate,
            sendNow: this.form.sendNow,
            isTargetRecipients: this.form.isTargetRecipients,
        });
        // this.setNotificationFormData({
        //   name: this.form.name,
        //   image: this.form.image,
        //   messageBody: this.form.messageBody,
        //   actionButtonLabel: this.form.actionButtonLabel,
        // });
    }
    get yesterday() {
        return moment().subtract(1, 'days').toISOString();
    }
    // private isTargetRecipients = false;
    get activeDailyRecurringLabel() {
        return `All Active Daily Recurring Subscribers (${this.activeSubscribersCount})`;
    }
    messageBodyText() {
        if (this.form.typeOfNotification === 'new_product_announcement') {
            return `Big news! We've launched something new. Check it out and be one of the first!`;
        }
        if (this.form.typeOfNotification === 'product_discount_promotion') {
            return `🔥 Don't miss out! Get an exclusive discount on this product now and save big!`;
        }
        if (this.form.typeOfNotification === 'product_promotion') {
            return `⚡ Discover products you'll love! Check out our top picks before they're gone.`;
        }
        return '';
    }
    get deliverySchedules() {
        return [
            selectOptionBuilder(NotificationDeliverySchedule.sendNow),
            selectOptionBuilder(NotificationDeliverySchedule.scheduleDate),
        ];
    }
    fileExceed() {
        this.fileExceeded = true;
        this.checkRejectedFiles();
        this.errorNotification('Exceeded total Number of files');
    }
    checkRejectedFiles() {
        const self = this;
        this.hasRejectedFiles = !!self.$refs.uploader.getRejectedFiles().length;
    }
    get customNotificationNameErrors() {
        const errors = [];
        if (!this.$v.form.name.$dirty) {
            return errors;
        }
        if (!this.$v.form.name.required) {
            const msg = requiredProperty('Custom Notification Name');
            errors.push(msg);
        }
        return errors;
    }
    get customerMessageBody() {
        const errors = [];
        if (!this.$v.form.messageBody.$dirty) {
            return errors;
        }
        if (!this.$v.form.messageBody.required) {
            const msg = requiredProperty('Custom Message Body');
            errors.push(msg);
        }
        return errors;
    }
    // public get notificationTitle() {
    //   const errors: TranslateResult[] = [];
    //   if (!this.$v.form.title!.$dirty) {
    //     return errors;
    //   }
    //   if (!this.$v.form.title!.required) {
    //     const msg = requiredProperty('Notification Title');
    //     errors.push(msg);
    //   }
    //   return errors;
    // }
    get deliveryScheduleErrors() {
        const errors = [];
        if (!this.$v.form.sendNow.$dirty) {
            return errors;
        }
        if (!this.$v.form.sendNow.required) {
            const msg = requiredProperty('Custom Message Body');
            errors.push(msg);
        }
        return errors;
    }
    get actionButtonErrors() {
        const errors = [];
        if (!this.$v.form.actionButtonLabel.$dirty) {
            return errors;
        }
        if (!this.$v.form.actionButtonLabel.required) {
            const msg = requiredProperty('Action button');
            errors.push(msg);
        }
        return errors;
    }
    get htmlError() {
        if (this.hasSubmitted) {
            const strippedMessageBody = this.stripHtmlTags(this.form.messageBody || '');
            if (strippedMessageBody?.length === 0) {
                return ['Custom Message Body is required'];
            }
        }
        return [];
    }
    stripHtmlTags(input) {
        return input.replace(/<[^>]*>/g, '').trim();
    }
    async onSubmit() {
        this.hasSubmitted = true;
        this.$v.$touch();
        const strippedMessageBody = this.stripHtmlTags(this.form.messageBody || '');
        if (!this.$v.$invalid && strippedMessageBody?.length > 0) {
            this.sending = true;
            const mutation = () => (this.formData ? this.editNotification() : this.createNotification());
            await mutation()
                .then(async ({ data }) => {
                const notificationUuid = data?.createCustomNotification?.notification?.uuid ||
                    data?.editCustomNotification?.notification?.uuid;
                if (isNotEmpty(this.form.image?.length)) {
                    // this.uploadingOnProgress();
                    const deletedImagesUuids = this.getDeletedImageUuids(this.form.image);
                    const newImages = this.filterNewImages(this.form.image);
                    if (isNotEmpty(newImages?.length)) {
                        await this.notificationImageUploader(notificationUuid, newImages);
                    }
                    if (isNotEmpty(deletedImagesUuids?.length)) {
                        await this.removeNotificationImages(notificationUuid, deletedImagesUuids);
                    }
                    // this.uploadingDone();
                }
                const msg = successfulCreate('Notification');
                this.successNotification(msg);
                // this.goToProductsPage();
            })
                .catch((e) => {
                this.sending = false;
                this.errorNotification(e.message);
            })
                .finally(() => {
                this.sending = false;
                this.setNotificationFormData({});
                this.$emit('refetch');
            });
        }
    }
    onCancel() {
        this.$emit('cancel');
    }
    async createNotification() {
        const vm = this;
        const scheduleDateISO = !vm.form.sendNow ? new Date(vm.form.scheduleDate).toISOString() : null;
        const variables = {
            input: {
                appUuid: vm.appUUID,
                name: vm.form.name,
                notificationType: vm.form.typeOfNotification,
                // title: vm.form.title,
                message: vm.form.messageBody,
                buttonText: vm.form.actionButtonLabel,
                sendToAllActive: vm.form.allActiveDailySubscribers,
                productUuid: vm.form.productUuid.value,
                sendNow: vm.form.sendNow,
                sendAt: scheduleDateISO,
                withImage: vm.checkImageUnshow,
            },
        };
        if (vm.form.customerSegments) {
            variables.input.customerSegmentUuids = vm.form.customerSegments.map((segment) => segment.value);
        }
        return this.$apollo
            .mutate({
            mutation: CreateSubscriptionNotification,
            variables,
        })
            .catch((e) => {
            console.error(e.message);
            this.errorNotification(e.message);
        });
    }
    async editNotification() {
        const vm = this;
        const scheduleDateISO = !vm.form.sendNow ? new Date(vm.form.scheduleDate).toISOString() : null;
        const variables = {
            input: {
                customSubscriptionNotificationUuid: vm.form.customSubscriptionNotificationUuid,
                name: vm.form.name,
                notificationType: vm.form.typeOfNotification,
                // title: vm.form.title,
                message: vm.form.messageBody,
                buttonText: vm.form.actionButtonLabel,
                sendToAllActive: vm.form.allActiveDailySubscribers,
                productUuid: vm.form.productUuid.value,
                sendNow: vm.form.sendNow,
                sendAt: scheduleDateISO,
                withImage: vm.checkImageUnshow,
            },
        };
        if (vm.form.customerSegments) {
            variables.input.customerSegmentUuids = vm.form.customerSegments.map((segment) => segment.value);
        }
        return this.$apollo
            .mutate({
            mutation: EditSubscriptionNotification,
            variables,
        })
            .catch((e) => {
            console.error(e.message);
            this.errorNotification(e.message);
        });
    }
    async notificationImageUploader(notificationUuid, images) {
        const inputImages = images.map((input) => input.file);
        await this.$apollo.mutate({
            mutation: NotificationUploadImage,
            variables: {
                input: {
                    customSubscriptionNotificationUuid: notificationUuid,
                    images: inputImages,
                },
            },
        });
    }
    async removeNotificationImages(notificationUuid, imageUuids) {
        await this.$apollo.mutate({
            mutation: NotificationRemoveImage,
            variables: {
                input: {
                    customSubscriptionNotificationUuid: notificationUuid,
                    photos: imageUuids,
                },
            }
        });
    }
    get isB2cBundle() {
        return (this.$route.params.key === Bundle.Ecommerce || this.$props?.serviceBundle === ECOMMERCE_B2C);
    }
    get isShopifyBundle() {
        return this.$route.params.key === Bundle.Shopify || this.$props?.serviceBundle === SHOPIFY;
    }
    get isInsuranceBundle() {
        return this.$route.params.key === Bundle.Insurance;
    }
    mounted() {
        if (this.formData) {
            // this.isTargetRecipients = isTargetRecipients;
            this.form = this.formData;
            // this.form.customerSegments = segments;
        }
        else {
            this.assignChangedFormData();
            // await this.assignChangedFormData();
            this.form = this.notificationFormData;
        }
    }
};
__decorate([
    Mutation('setNotificationFormData')
], ComponentName.prototype, "setNotificationFormData", void 0);
__decorate([
    Getter('notificationFormData')
], ComponentName.prototype, "notificationFormData", void 0);
__decorate([
    Prop({ type: Object, default: null })
], ComponentName.prototype, "formData", void 0);
__decorate([
    Watch('form.name')
], ComponentName.prototype, "onNameChange", null);
__decorate([
    Watch('form.messageBody')
], ComponentName.prototype, "onMessageBodyChange", null);
__decorate([
    Watch('form.actionButtonLabel')
], ComponentName.prototype, "onActionButtonLabelChange", null);
__decorate([
    Watch('form.image')
], ComponentName.prototype, "onImageChange", null);
__decorate([
    Watch('form.sendNow')
], ComponentName.prototype, "onDateTimeChange", null);
ComponentName = __decorate([
    Component({
        components: {
            Uploader,
            BaseTextField,
            BaseTextArea,
            ActionButton,
            BaseImagePlaceholder,
            VEditorField,
            DateTimeField,
        },
        apollo: {
            appProducts: {
                query: FetchProducts,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    return data.fetchKeywordProducts.edges.map(({ node }) => {
                        return node;
                    });
                },
            },
            appSegments: {
                query: AppSegmentations,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    const node = (segment) => {
                        return new AppSegmentationBasicModel(segment.node);
                    };
                    return data.appSegmentations.edges.map(node);
                },
            },
            activeSubscribersCount: {
                query: FetchSubscriberCount,
                variables() {
                    return {
                        appUuid: this.appUUID,
                        keyword: null,
                        selectedFilter: null,
                    };
                },
                update(data) {
                    return data.fetchInboxRecipients.activeSubscriberTotal;
                },
            },
            defaultProduct: {
                query: FetchDefaultProduct,
                variables() {
                    return {
                        appUuid: this.appUUID,
                        notifType: this.form.typeOfNotification,
                    };
                },
                update(data) {
                    if (!this.formData) {
                        this.form.messageBody = this.messageBodyText();
                    }
                    if (data.fetchNotificationDefaultProduct) {
                        this.form.productUuid = {
                            text: data.fetchNotificationDefaultProduct?.name,
                            value: data.fetchNotificationDefaultProduct?.uuid,
                        };
                    }
                    else {
                        this.form.productUuid = null;
                    }
                    return data.fetchNotificationDefaultProduct;
                },
            },
        },
        validations() {
            const vm = this;
            const deliveryScheduleIsScheduledDate = () => vm.form.sendNow === false;
            const productPayload = () => vm.productType.some((type) => type === vm.form.typeOfNotification);
            const validations = {
                form: {
                    name: {
                        required,
                    },
                    customerSegments: {
                        required: requiredIf(() => vm.form.isTargetRecipients),
                    },
                    // title: {
                    //   required,
                    // },
                    messageBody: {
                        required,
                        maxLength: maxLength(80),
                    },
                    actionButtonLabel: {
                        required,
                    },
                    sendNow: {
                        required,
                    },
                    scheduleDate: {
                        required: requiredIf(() => deliveryScheduleIsScheduledDate()),
                    },
                    typeOfNotification: {
                        required,
                    },
                    productUuid: {
                        required: requiredIf(() => productPayload()),
                    },
                },
            };
            return validations;
        },
    })
], ComponentName);
export default ComponentName;
